const namespace = window.VelotricBundle
if (!namespace?.["shell"]?.ready) { throw new Error("vl-bundle-shell.js must execute before vl-bundle-catalog.js") }
const sharedApi = namespace["shell"].api
if (!sharedApi) { throw new Error("Missing shell named API contract") }
export const getStylePropValue = sharedApi["getStylePropValue"]
export const getTemplateContent = sharedApi["getTemplateContent"]
export const getTemplateFirstChild = sharedApi["getTemplateFirstChild"]
export const hideElement = sharedApi["hideElement"]
export const parseHTML = sharedApi["parseHTML"]
export const removeStyleVariable = sharedApi["removeStyleVariable"]
export const replaceNodeChildren = sharedApi["replaceNodeChildren"]
export const setStyleVariable = sharedApi["setStyleVariable"]
export const showElement = sharedApi["showElement"]
export const skipTransition = sharedApi["skipTransition"]